export default __webpack_public_path__ + "static/749-17dd047dff68f43fc1d2d76c37ccd2f2.gif";